function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useLayoutEffect, useRef } from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { useSpring } from '@react-spring/web';
export function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
} // a hook that listens for a change in isOpened
// and initiates a height animation

export function useAnimateHeight(_ref) {
  var containerRef = _ref.containerRef,
      isOpened = _ref.isOpened;

  var _useSpring = useSpring(function () {
    return {
      height: ''
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      height = _useSpring2[0].height,
      api = _useSpring2[1];

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isAtRest = _React$useState2[0],
      setIsAtRest = _React$useState2[1];

  var prevContainerHeights = useRef([]);

  var animateHeight = function animateHeight(_ref2) {
    var prevHeight = _ref2.prevHeight,
        currentHeight = _ref2.currentHeight;
    if (!containerRef.current) return;
    setIsAtRest(false);
    api.start({
      height: prevHeight,
      immediate: true
    });
    api.start({
      height: currentHeight,
      config: {
        tension: 247,
        friction: 31
      },
      immediate: false,
      onRest: function onRest(_ref3) {
        var height = _ref3.height;
        var animationIsInProgress = height !== prevContainerHeights.current[0] && height !== prevContainerHeights.current[1];
        if (animationIsInProgress) return;
        requestAnimationFrame(function () {
          api.start({
            height: '',
            immediate: true,
            onRest: function onRest() {}
          });
        });
        setIsAtRest(true);
      }
    });
  };

  useLayoutEffect(function () {
    if (!containerRef.current) return; // if we're interrupting an animation, just use the previously cached height

    var currentHeight = isAtRest ? containerRef.current.offsetHeight : prevContainerHeights.current[0];
    var isInitialLayout = !prevContainerHeights.current.length;

    if (!isInitialLayout) {
      animateHeight({
        currentHeight: currentHeight,
        prevHeight: prevContainerHeights.current.slice(-1)[0]
      });
    }

    prevContainerHeights.current = prevContainerHeights.current.slice(-1).concat(currentHeight);
  }, [isOpened]); // eslint-disable-line

  return [height, isAtRest];
}
export var MaskDictKey;

(function (MaskDictKey) {
  MaskDictKey["Date"] = "date";
  MaskDictKey["PhoneNumber"] = "phoneNumber";
  MaskDictKey["SSN"] = "socialSecurity";
  MaskDictKey["Currency"] = "currency";
  MaskDictKey["Percent"] = "percent";
})(MaskDictKey || (MaskDictKey = {}));

export var maskDict = {
  currency: createNumberMask({
    allowDecimal: true
  }),
  percent: createNumberMask({
    prefix: '',
    suffix: '%'
  }),
  socialSecurity: [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  phoneNumber: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/],
  date: [/\d/, /[0-9]/, '/', /\d/, /[0-9]/, '/', /\d/, /\d/, /\d/, /\d/]
};
export function getTextMask(mask) {
  return typeof mask === 'string' ? maskDict[mask] : mask;
}